import React from 'react'
import { Routes, Route } from 'react-router'
import { Layout } from './components/Layout.jsx'
import { Dashboard } from './pages/Dashboard.jsx'
import { Promos } from './pages/Promos.jsx'
import { Planner } from './pages/Planner.jsx'
import { Stock } from './pages/Stock.jsx'
import { Shopping } from './pages/Shopping.jsx'
import { History } from './pages/History.jsx'
import { Household } from './pages/Household.jsx'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="promos" element={<Promos />} />
        <Route path="planner" element={<Planner />} />
        <Route path="stock" element={<Stock />} />
        <Route path="shopping" element={<Shopping />} />
        <Route path="household" element={<Household />} />
        <Route path="history" element={<History />} />
      </Route>
    </Routes>
  )
}
